import { Component, OnInit } from '@angular/core';
import {ColumnApi, GridApi} from "ag-grid-community";
import {Observable, Subscription} from "rxjs";
import {ApiResponse} from "../../../../model/interfaces/response";
import {HttpControllers} from "../../../../utils/Class/HttpController";
import {DATA_SOURCE} from "../../../../../environments/environment";
import {
  Banco,
  IdEmpresa, KeyValue,
  operacionesSap, ParametrosGenerales,
  ParamExtracionBanca,
  TipoMovimiento
} from "../../models/recuadosBancario/ParamExtracionBanca";
import {HttpClient} from "@angular/common/http";
import {moduloCobrosAutoservicio} from "../../diccionarios/cobrosAutoServiciosModulo";
import {LfsaBotonEditarGridComponent} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {PAGE_VISUALIZER,PARAM_CONFIG} from "../../diccionarios/constRecaudo";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {DatosMaestrosService} from "../../../../services/datos-maestros.service";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {RecaudoBancarioService} from "../../services/recaudoBancario/recaudo-bancario.service";
import { AG_GRID_LOCALE_ES } from "../../../../utils/ag-grid-es";
import {ExcelServiceService} from "../../../portal-compras/services/excel-service.service";
@Component({
  selector: 'app-extracto-bancario-config',
  templateUrl: './extracto-bancario-config.component.html',
  styleUrls: ['./extracto-bancario-config.component.css']
})
export class ExtractoBancarioConfigComponent implements OnInit {

  gridApi: GridApi;
  modulo: any = {};
  gridColumnApi: ColumnApi;
  columnsConfig: any[] = [];
  frameworkComponents: any;
  pageVisualizer: string = PAGE_VISUALIZER.INICIO;
  PAGE_VISUALIZER = PAGE_VISUALIZER;
  formulario: FormGroup;
  formularioParam: FormGroup;
  private subscription: Subscription;
  private subscriptionOp: Subscription;
  diasTolerancia: number = 0;
  l10nAgGrid = AG_GRID_LOCALE_ES;

  cmbEmpresa: IdEmpresa[] = [];
  cmbBancos:  Banco[] = [];
  //cmbOperaciones : operacionesSap[] = [];
  cmbOperaciones : any[] = [];
  cmbTipoMovimiento : TipoMovimiento[] = [];
  cmbParametros : ParametrosGenerales[] = [];
  cmbSignos : KeyValue[] = [];

  public dataSource$ :Observable<ApiResponse<ParamExtracionBanca[]>> = new HttpControllers(this.httpClient)
    .read({
      datasource: DATA_SOURCE.VDI,
      path: 'recaudo/config/all'
    });

  public dataSourceOp$ :Observable<ApiResponse<operacionesSap[]>> ;
  public dataSourceBanco$ :Observable<ApiResponse<Banco[]>> ;
  public dataSourceParam$ :Observable<ApiResponse<ParametrosGenerales[]>> ;
  constructor(private httpClient: HttpClient,
              private formBuilder: FormBuilder,
              private _datosMaestros: DatosMaestrosService,
              private _utils: UtilsService,
              private _recaudoservice: RecaudoBancarioService,
              public excelService: ExcelServiceService) {

  }

  ngOnInit(): void {
    this.modulo = moduloCobrosAutoservicio;
    const $this = this;
    this.columnsConfig = [
      { field: "idConfig",filter: true ,sortable: true, width: 90},
      //{ field: "idEmpresa.idEmpresa",filter: true ,sortable: true },
      { field: "idEmpresa.dscaEmpresa", headerName: "Empresa", filter: true ,sortable: true,width: 120 },
      { field: "idBanco",filter: true ,sortable: true, width: 90,  resizable: false,minWidth: 90 },
      { field: "bancoDesc",filter: true ,sortable: true,minWidth: 150},
      { field: "idCuenta",filter: true ,sortable: true,width: 100, minWidth: 100},
      { field: "tipoMovimiento",filter: true ,sortable: true,
        width: 150,
        suppressSizeToFit: false,
        valueGetter: function (data) {
          let codigo = data.data.tipoMovimiento;
          return $this._recaudoservice.getTiposMovimientos().find(x => x.codigo == codigo).descripcion;
        }
      },
      { field: "codOperacionSap",
        headerName: "Operacion Sap" ,
        filter: true ,
        sortable: true,
        width: 150,
        minWidth: 100,
        resizable: false,
        suppressSizeToFit: false
        /*valueGetter: function (data) {
          let codigo = data.data.idOpInternaSap.operacionInternaSap;
          let nombre = data.data.idOpInternaSap.descripcionConcepto;
          return codigo + " - " + nombre;
        }*/
      },
      { field: "signo", headerName: "Signo" ,filter: true ,sortable: true, width: 100},
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 130,
        pinned: 'left',
        cellRendererParams: {
          onClick: this.elimarConfig.bind(this),
          label: 'Eliminar',
          colorBoton: this.modulo.button.buttonsCss.danger
        }
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.formulario = this.formBuilder.group({
      idBanco: ['', Validators.required],
      idCuenta: ['', Validators.required],
      tipoMovimiento: ['', Validators.required],
      userRegistro: [''],
      idEmpresa: this.formBuilder.group({
        idEmpresa: ['', Validators.required]
      }),
/*      idOpInternaSap: this.formBuilder.group({
        id: ['', Validators.required],
        signo: ['']
      }),*/
      codOperacionSap: ['', Validators.required],
      signo: ['', Validators.required]
    });

    this.formularioParam = this.formBuilder.group({
      idParametro: [null, Validators.required],
      valorParametroNum: [null,Validators.required]
    });

    this.cargarEmpresa();
    this.cargaTiposMovimeintos();
    this.cargaSignos();
    this.setPararemtro();
  }

  onGridReady(params) {
    this.gridColumnApi = params.columnApi;
    this.gridApi = params.api;
    //this.gridApi.sizeColumnsToFit();
    //params.api.sizeColumnsToFit();
  }

  onLogout() {
    window.location.reload();
  }

  toggleVisualizacion(): void {
    this.pageVisualizer = this.pageVisualizer === PAGE_VISUALIZER.INICIO ? PAGE_VISUALIZER.AGREGAR : PAGE_VISUALIZER.INICIO ;
  }
  ngOnDestroy() {
    console.log("Destroy");
    this.subscription?.unsubscribe();
    this.subscriptionOp?.unsubscribe();
  }

  cargarEmpresa() {
    this.subscription = this._datosMaestros.getAllEmpresas().subscribe((resp : IdEmpresa[]) => {
      console.log(resp);
      this.cmbEmpresa = resp;
    }, (error) => {
      this.cmbEmpresa = [];
      console.log(error);
    });
  }

  setBanco() {
    const  idEmpresa = this.formulario.get('idEmpresa').get('idEmpresa').value;

    if (this._utils.IsNull(idEmpresa)) {
      console.log("Error: idBanco o idEmpresa no pueden ser vacios");
      return;
    }
    this.dataSourceBanco$ = this._recaudoservice.cargarBancoEmpresa(idEmpresa);

    this.subscriptionOp = this.dataSourceBanco$.subscribe((resp: ApiResponse<Banco[]>) => {
      this.cmbBancos = resp.respuesta;
    }, (error) => {
      this.cmbBancos = [];
      console.log(error);
    });
  }

  setCuenta() {
    this.formulario.get('idCuenta').setValue(this.buscarCuentaBancaria(this.formulario.get('idEmpresa').get('idEmpresa').value,
                                                                        this.formulario.get('idBanco').value));
  }

  buscarCuentaBancaria(idEmpresa: string, idBanco: string): string {
    if (this._utils.IsNull(idEmpresa) || this._utils.IsNull(idBanco)) {
      console.log("Error: idBanco o idEmpresa no pueden ser vacios");
      return " ";
    }
    const banco = this.cmbBancos.find(b => b.idEmpresa === idEmpresa && b.idBanco === idBanco);
    // Si el banco existe y tiene lista de cuentas
    if (banco && banco.listaCuentas) {
       return banco.listaCuentas.cuentaBancaria;
    }
    // Si no se encuentra el banco o la cuenta, retornar undefined
    return " ";
  }

/*  setOperacionSap() {
    const  idBanco = this.formulario.get('idBanco').value;
    const  idEmpresa = this.formulario.get('idEmpresa').get('idEmpresa').value;

    if (this._utils.IsNull(idEmpresa) || this._utils.IsNull(idBanco)) {
      console.log("Error: idBanco o idEmpresa no pueden ser vacios");
      return;
    }
    this.dataSourceOp$ = this._recaudoservice.cargaOperaciones(idEmpresa, idBanco);

    this.subscriptionOp = this.dataSourceOp$.subscribe((resp: ApiResponse<operacionesSap[]>) => {
      this.cmbOperaciones = resp.respuesta;
    }, (error) => {
      this.cmbOperaciones = [];
      console.log(error);
    });
  }*/

  setCodOperacionSap() {
    const  idBanco = this.formulario.get('idBanco').value;
    const  idEmpresa = this.formulario.get('idEmpresa').get('idEmpresa').value;

    if (this._utils.IsNull(idEmpresa) || this._utils.IsNull(idBanco)) {
      console.log("Error: idBanco o idEmpresa no pueden ser vacios");
      return;
    }

    this._recaudoservice.cargaCodOperaciones(idEmpresa, idBanco).subscribe((resp : any) => {
     this.cmbOperaciones= resp.respuesta;
   });

   /* this.dataSourceOp$.subscribe((resp: ApiResponse<operacionesSap[]>) => {
      this.cmbOperaciones = resp.respuesta;
    }, (error) => {
      this.cmbOperaciones = [];
      console.log(error);
    });*/

  }

/*
  buscarCSigno(idRegla): string {
    if (this._utils.IsNull(idRegla) ) {
      console.log("Error: idRegla no pueden ser vacios");
      return " ";
    }
    const regla = this.cmbOperaciones.find(b => b.idRegla === idRegla );
    // Si el banco existe y tiene lista de cuentas
    if (regla) {
      return regla.signo;
    }
    // Si no se encuentra el banco o la cuenta, retornar undefined
    return " ";
  }

  setSigno() {
    this.formulario.get('idOpInternaSap.signo').setValue(this.buscarCSigno(this.formulario.get('idOpInternaSap.id').value));
  }
*/

  cargaTiposMovimeintos(){
    this.cmbTipoMovimiento = this._recaudoservice.getTiposMovimientos();
  }

  cargaSignos(){
    this.cmbSignos = this._recaudoservice.getSignos();
  }
  setPararemtro() {

    this.dataSourceParam$ = this._recaudoservice.cargaParametrosGenerales(PARAM_CONFIG.NODE_RECAUDO_DIAS_TOLERANCIA);
    this.subscriptionOp?.unsubscribe();
    this.subscriptionOp = this.dataSourceParam$.subscribe((resp: ApiResponse<ParametrosGenerales[]>) => {
      this.cmbParametros = resp.respuesta;
      this.formularioParam.get('valorParametroNum').setValue(this.cmbParametros[0].valorParametroNum);
    }, (error) => {
      this.cmbBancos = [];
      console.log(error);
    });
  }

  EnviarGuardar(){
    this.formulario.get('userRegistro').setValue(localStorage.getItem('userName'));
    console.log(this.formulario.value);
    this._recaudoservice.enviarGuardarParamRecaudo(this.formulario.value)
      .subscribe((resp) => {
          console.log("Save->",resp);
          this._utils.mensajeOKVisto(resp.mensaje,false);
          this._utils.clearFormFields(this.formulario);
          this.pageVisualizer = PAGE_VISUALIZER.INICIO;

      }, (error) => {
        console.log("Save er->",error);
        this._utils.mensajeErrorVisto(error.error.mensaje,true);
      })

  }

  Cancelar(){
    this._utils.clearFormFields(this.formulario);
    console.log(this.formulario.value);
    this.pageVisualizer = PAGE_VISUALIZER.INICIO;
  }
  guardarDiasTolerancia(){
    console.log("save tolerancia")
    this.formularioParam.get('idParametro').setValue(this.cmbParametros[0].idParametro);
    this._recaudoservice.actualizaParametrosGeneralesValues(this.formularioParam.value)
      .subscribe((resp) => {
        console.log("Save->",resp);
        this._utils.mensajeOKVisto(resp.mensaje,false);
      }, (error) => {
        console.log("Save er->",error);
        this._utils.mensajeErrorVisto(error.error.mensaje,true);
      }
      )
  }

  elimarConfig({rowData}){
    console.log(rowData)
    this._recaudoservice.eliminarParametrosGeneralesValues(rowData.idConfig).subscribe( (resp) => {
      this._utils.mensajeOKVisto(resp.mensaje,false);
      this.onLogout();
    } , (error) => {
      console.log(error)
      this._utils.mensajeErrorVisto(error.mensaje,true);
    });
  }

  exportAsExcel(): void {
    this.excelService.exportToExcel(this.gridApi, {
      fileName: 'Configuracion Extracto'+this._utils.getCurrentDateGuion()+'.xlsx',
      sheetName: 'Configuracion Extracto',
      columns: [
        {
          header: 'idConfig',
          key: 'idConfig', // field name here
          width: 15 // width of the column
        },
        {
          header: 'Empresa',
          key: 'idEmpresa.dscaEmpresa',
          width: 15
        },
        {
          header: 'idBanco',
          key: 'idBanco', // field name here
          width: 15 // width of the column
        },
        {
          header: 'Banco',
          key: 'bancoDesc',
          width: 15
        },
        {
          header: 'Id Cuenta',
          key: 'idCuenta',
          width: 15,
        },
        {
          header: 'Tipo Movimiento',
          key: 'tipoMovimiento',
          width: 15,
        },
        {
          header: 'Operacion sap',
          key: 'codOperacionSap',
          width: 15,
        },
        {
          header: 'Signo',
          key: 'signo',
          width: 20
        }

      ]
    });
  }

}

